import React, {Component} from 'react';
import {connect} from 'react-redux';
import {addFavorite, addJournalPost, addLink} from '../../../../../state/actions/updateDataActions';
import 'date-fns';
// import AddFolderDialog from '../../explore/folders/AddFolderDialog';
import ItemFormDialog from './ItemFormDialog';

class AddItemDialog extends Component {
  state = {
    item: {
      name: '',
      description: '',
      keywords: [],
      people: [],
      emotion: '',
      beme: '',
      date: new Date(),
      location: null,
      folder:this.props.folderList[0],
      ...this.props.addItemProps
    },
    peopleList: [],
    keywordsList: [],
    folderList: [],
    mindfileFilterValues: {
      keywords: [],
      people: [],
      folders: [],
    },
  }

  // componentDidMount() {
  //   this.props.getFolderList(this.props.mindfile.id, () => {
  //     let folder = this.props.folderList.length > 0 ? this.props.folderList[0] : null;
  //     this.handleItemChange({folder: folder});
  //   });
  //   this.props.getFilterValues(this.props.mindfile.id);
  // }

  handleSave() {
    let item = this.state.item;
    switch(this.props.itemType){
      case 'Link':
        this.props.addLink(item, this.props.itemChangeCallback);
        break;
      case 'Favorite':
        this.props.addFavorite(item, this.props.itemChangeCallback);
        break;
      case 'JournalPost':
        this.props.addJournalPost(item, this.props.itemChangeCallback);
        break;
      case 'SurveyAttempt':
        // this.props.startSurvey(item, this.props.itemChangeCallback);
        break;
      default:
        break;
    }
    this.handleItemChange({
      name: '',
      description: '',
      keywords: [],
      people: [],
      emotion: '',
      beme: '',
      date: null,
      location: null,
      folder:this.props.folderList[0],
      ...this.props.addItemProps
    });
    this.props.closeDialog();
  }

  handleCancel(){
    this.props.closeDialog();
  }

  handleItemChange(item) {
    this.setState({item: {...this.state.item, ...item}});
  }

  render() {
    return (
      <ItemFormDialog
        mindfileUserLevel={this.props.mindfileUserLevel}
        id="addItemDialog"
        item={this.state.item}
        itemType={this.props.itemType}
        handleItemChange={this.handleItemChange.bind(this)}
        keywordsList={this.props.mindfileFilterValues.keywords}
        peopleList={this.props.mindfileFilterValues.people}
        folderList={this.props.folderList}
        addFolder={this.props.addFolder.bind(this)}
        title={`Add ${this.props.itemType === 'JournalPost' ? 'Journal Post' : this.props.itemType === 'SurveyAttempt' ? 'Profile Assessment' : this.props.itemType}`}
        isOpen={this.props.isOpen}
        handleSave={this.handleSave.bind(this)}
        handleCancel={this.handleCancel.bind(this)}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return ({
  //   folderList: state.folderList,
    mindfile: state.mindfile,
  //   mindfileFilterValues: state.mindfileFilterValues,
    mindfileUserLevel: state.mindfileUserLevel,
  });
}

const mapDispatchToProps = {
  addFavorite,
  addJournalPost,
  addLink,
  // addFolder,
  // getFolderList,
  // getFilterValues
};

export default connect(mapStateToProps, mapDispatchToProps)(AddItemDialog);
